module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-rp.ca614a3f.png";